import { Component, Inject } from '@angular/core';
import { WINDOW } from '@services';

@Component({
  selector: 'app-financial-monitoring-info',
  templateUrl: './financial-monitoring-info.component.html',
  styleUrls: ['./financial-monitoring-info.component.scss'],
})
export class FinancialMonitoringInfoComponent {}
